module.exports = __webpack_public_path__ + "img/fill2.408a4c97.svg";